import type { ReactNode } from 'react';
import { CalendarBadge } from '@/components/ui/calendar-badge';
import { cn } from '@/lib/utils';

type TimelineDayGroupProps = {
  day: string;
  month: string;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
};

export function TimelineDayGroup({
  day,
  month,
  children,
  className,
  contentClassName,
}: TimelineDayGroupProps) {
  return (
    <div className={cn('relative flex gap-4 not-first:border-t not-first:pt-3 border-foreground/5', className)}>
      <CalendarBadge day={day} month={month} />
      <div className={cn('flex-1 space-y-3', contentClassName)}>{children}</div>
    </div>
  );
}
